"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessService = void 0;
const api_1 = require("../api");
class AccessService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        this.fetch = fetch;
    }
    basePath(resourceType) {
        return `/${this.apiVersion}/access/${resourceType}`;
    }
    listGroups() {
        return this.fetch(this.basePath("groups"), {
            method: "GET",
        });
    }
    createGroup(params) {
        return this.fetch(this.basePath("groups"), {
            method: "POST",
            body: params.group,
        });
    }
    getGroup(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}`, {
            method: "GET",
        });
    }
    updateGroup(params) {
        return this.fetch(this.basePath("groups"), {
            method: "POST",
            body: params.group,
        });
    }
    deleteGroup(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}`, {
            method: "DELETE",
        });
    }
    listGroupUsers(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}/users`, {
            method: "GET",
        });
    }
    addGroupUser(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/users/${encodeURIComponent(params.userId)}`, {
            method: "PUT",
        });
    }
    removeGroupUser(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/users/${encodeURIComponent(params.userId)}`, {
            method: "DELETE",
        });
    }
    listGroupRoles(params) {
        return this.fetch(`${this.basePath("groups")}/${params.id}/roles`, {
            method: "GET",
        });
    }
    addGroupRole(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/roles/${params.roleId}`, {
            method: "PUT",
        });
    }
    removeGroupRole(params) {
        return this.fetch(`${this.basePath("groups")}/${params.groupId}/roles/${params.roleId}`, {
            method: "DELETE",
        });
    }
    listRoles() {
        return this.fetch(this.basePath("roles"), {
            method: "GET",
        });
    }
    getRole(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}`, {
            method: "GET",
        });
    }
    createRole(params) {
        return this.fetch(this.basePath("roles"), {
            method: "POST",
            body: params.role,
        });
    }
    updateRole(params) {
        return this.fetch(this.basePath("roles"), {
            method: "POST",
            body: params.role,
        });
    }
    deleteRole(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}`, {
            method: "DELETE",
        });
    }
    listRoleGroups(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}/groups`, {
            method: "GET",
        });
    }
    listRolePermissions(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}/permissions`, {
            method: "GET",
        });
    }
    setRolePermissions(params) {
        return this.fetch(`${this.basePath("roles")}/${params.id}/permissions`, {
            method: "PUT",
            body: params.permissions,
        });
    }
    listUsers() {
        return this.fetch(this.basePath("users"), {
            method: "GET",
        });
    }
    getUser(params) {
        return this.fetch(`${this.basePath("users")}/${encodeURIComponent(params.id)}`, {
            method: "GET",
        });
    }
    getUserGroups(params) {
        return this.fetch(`${this.basePath("users")}/${encodeURIComponent(params.id)}/groups`, {
            method: "GET",
        });
    }
}
exports.AccessService = AccessService;
exports.default = AccessService;
